import React from 'react';

export default function Cabang() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Cabang</h1>
      <p className="text-gray-500">Halaman Cabang</p>
    </div>
  );
}
